import React from "react";
import {
  PawPrint,
  Telescope,
  Crown,
  Lightbulb,
  ScrollText,
  Brain,
  FlaskConical,
  Globe2,
  Leaf,
  Sparkles,
} from "lucide-react";

const MAP = {
  PawPrint,
  Telescope,
  Crown,
  Lightbulb,
  ScrollText,
  Brain,
  FlaskConical,
  Globe2,
  Leaf,
};

export const SubjectIcon = ({ name, ...props }) => {
  const Icon = MAP[name] || Sparkles;
  return <Icon {...props} />;
};
